import {useMemo} from 'react';
import {applyTimezone, currencyFormat, dateShortFormat, datetimeShortFormat} from '../../utils';

export function ServiceRow({service, isReservation = false, isLastRoom = false, isFirst, isLast, isSelected, isInvoiced, onClick}) {
    const duration = useMemo(() => {
        if (typeof service.date === 'string') {
            return datetimeShortFormat(applyTimezone(service.date));
        } else {
            return dateShortFormat(service.date.from) + ' - ' + dateShortFormat(service.date.to);
        }
    }, [service.date]);

    const className = `reservation-rooms__service select text-left ${isReservation ? 'reservation-rooms__service--reservation' : ''} ${isLastRoom && isLast ? 'reservation-rooms__service--rooms-last' : ''} ${isFirst ? 'reservation-rooms__service--first' : ''} ${isLast ? 'reservation-rooms__service--last' : ''} ${isSelected ? 'selected' : ''} ${isInvoiced ? 'danger' : ''}`;

    return <tr className="innerTable">
        <td colSpan="6">
            <table className="table table-wrap">
                <tbody>
                <tr className={className} onClick={onClick}>
                    <td className="col-xs-1"/>
                    <td className="col-xs-1 text-right no-br">{service.quantity}</td>
                    <td className="col-xs-3">{service.name}</td>
                    <td className="col-xs-3 no-br">{duration}</td>
                    <td className="col-xs-2">{service.reference.name}</td>
                    <td className="col-xs-2 text-right no-br">{currencyFormat(service.gross)}</td>
                </tr>
                </tbody>
            </table>
        </td>
    </tr>;
}
